// extracted by mini-css-extract-plugin
export default {"container":"TtDseNDMVfmBjuF4fNew","slides":"tEFv1rOYM3rxRAwi4lCg","fit":"opmB8YvcqsQKtC9Bj2o5"};